import React from 'react';
import { LabelStyled } from './styles';
var Label = function (props) {
    var children = props.children, _a = props.className, className = _a === void 0 ? '' : _a, variant = props.variant, _b = props.fontSize, fontSize = _b === void 0 ? 16 : _b, _c = props.fontFamily, fontFamily = _c === void 0 ? 'IBMPlexSans' : _c;
    switch (variant) {
        case 'bold': {
            return (React.createElement(LabelStyled, { className: className, "$fontFamily": fontFamily, "$fontWeight": 700, "$fontSize": fontSize }, children));
        }
        case 'semibold': {
            return (React.createElement(LabelStyled, { className: className, "$fontFamily": fontFamily, "$fontWeight": 600, "$fontSize": fontSize }, children));
        }
        case 'meduim': {
            return (React.createElement(LabelStyled, { className: className, "$fontFamily": fontFamily, "$fontWeight": 500, "$fontSize": fontSize }, children));
        }
        case 'regular':
        default: {
            return (React.createElement(LabelStyled, { className: className, "$fontFamily": fontFamily, "$fontWeight": 400, "$fontSize": fontSize }, children));
        }
    }
};
export default Label;
